import React from 'react';
import { Sparkles, Eye, MessageSquare, Calendar, CheckCircle, ThumbsDown } from 'lucide-react';
import { InquiryStatus } from '../../types/inquiry.types';

// Tenant-facing labels for an inquiry's status. The landlord dashboard uses its
// own label set (e.g. "New"/"Viewed"); tenants see what it means for them
// ("Sent", "Seen by landlord", "Accepted"…).
const CONFIG: Record<
  InquiryStatus,
  { label: string; className: string; Icon: React.ComponentType<{ className?: string }> }
> = {
  new: { label: 'Sent', className: 'bg-blue-100 text-blue-700 border-blue-200', Icon: Sparkles },
  viewed: { label: 'Seen by landlord', className: 'bg-purple-100 text-purple-700 border-purple-200', Icon: Eye },
  responded: { label: 'Landlord replied', className: 'bg-indigo-100 text-indigo-700 border-indigo-200', Icon: MessageSquare },
  scheduled: { label: 'Viewing scheduled', className: 'bg-yellow-100 text-yellow-700 border-yellow-200', Icon: Calendar },
  accepted: { label: 'Accepted', className: 'bg-green-100 text-green-700 border-green-200', Icon: CheckCircle },
  declined: { label: 'Declined', className: 'bg-gray-100 text-gray-700 border-gray-200', Icon: ThumbsDown },
};

interface InquiryStatusBadgeProps {
  status?: InquiryStatus;
  className?: string;
}

export const InquiryStatusBadge: React.FC<InquiryStatusBadgeProps> = ({ status, className = '' }) => {
  const config = status ? CONFIG[status] : undefined;
  if (!config) return null;
  const { label, className: badgeClass, Icon } = config;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] md:text-xs font-medium border ${badgeClass} ${className}`}
    >
      <Icon className="w-3 h-3" />
      {label}
    </span>
  );
};
